<template lang="pug">
  v-col(cols="12")
    v-list(v-if="loadingTasks" v-for="n in 3" :key="n" style="background:none")
      v-card(class="mb-4 rounded-lg")
        v-card-text
          v-list-item
            v-list-item-icon(class="handle")
              v-icon mdi-drag
            v-list-item-title
              v-skeleton-loader(type="heading")
        v-card-text.pt-0
          v-skeleton-loader(
            :types="{ 'task-tags': 'chip@5' }"
            type="task-tags"
          )
    v-list(style="background:none")
        v-card(
          v-if="!loadingTasks"
          v-for="task in tasks"
          :key="task.id"
          :data-id="task.id"
          class="task-item mb-4 rounded-lg"
        )
          v-card-text
            v-list-item
              v-list-item-icon(
                class="handle"
                @dragstart="setDataTransfer($event, task.id)"
                draggable
              )
                v-icon mdi-drag
              v-list-item-title {{ task.title }}
              v-list-item-action.flex-row
                v-btn(
                  v-if="folder && folder !== 'no_category'"
                  @click="unbindFromFolder(task.id, folder)"
                  :loading="unbindLoadings[task.id]"
                  color="error"
                  title="Удалить из папки"
                  fab
                  x-small
                )
                  v-icon mdi-folder-remove-outline
                v-btn.ml-2(
                  :to="{ name: 'TaskEdit', params: { id: task.id }}"
                  color="warning"
                  fab
                  x-small
                )
                  v-icon mdi-pencil
          v-card-text(class="pt-0 pl-8 tags-container" v-if="task.tags && task.tags.length > 0")
            v-slide-y-transition(group)
              v-hover(v-slot="{ hover }" v-for="tag in task.tags" :key="tag.id")
                v-chip(
                  :color="tag.color"
                  :dark="invertColor(tag.color)"
                  class="mr-2 mb-2 font-weight-bold"
                  @click="selectedTags = [tag.id]"
                  small
                ) {{ tag.name }}
                  v-slide-x-transition
                    v-btn.ml-2(
                      v-show="hover"
                      @click.prevent.stop="unbindTag(task.id, tag.id)"
                      class="tag__close"
                      :class="{ 'tag__close--opened': hover }"
                      :loading="tagLoadings[tag.id]"
                      icon x-small
                    )
                      v-icon(small) mdi-close-circle

    v-slide-y-reverse-transition
      div(v-if="!loadingTasks && !tasks.length" class="text-center")
        span(class="grey--text") Задания отсутствуют
</template>

<script>
import anime from 'animejs';
import draggable from 'vuedraggable';

import TaskService from '@/services/API/TaskService';

import { invertColor } from '@/utils/color-functions';

export default {
  name: 'TaskListItems',
  components: {
    draggable,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    folder: {
      type: [String, Number],
      default: '',
    },
    selectedTags: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      tagLoadings: {},
      unbindLoadings: {},
      tasks: [],
      loadingTasks: true,
    };
  },
  watch: {
    selectedTags() {
      this.getTaskList(this.searchInput);
    },
    folder() {
      this.getTaskList(this.searchInput);
    },
    search(val) {
      this.getTaskList(val);
    },
  },
  mounted() {
    this.getTaskList();
  },
  created() {
    this.$emit('inizialized', {
      removeTask: this.removeTask,
    });
  },
  methods: {
    invertColor,
    getTaskList(search) {
      const params = {};
      this.loadingTasks = true;
      // params['search[author]'] = this.userData.id;
      if (search) params['search[title]'] = search;
      if (this.selectedTags.length) params['search[tag]'] = this.selectedTags.join(',');
      if (this.folder) params['search[category]'] = this.folder;

      params[`search[${this.$route.meta.searchFilter}]`] = true;
      params.expand = 'tags';
      params['search[created_by]'] = this.$user.data.id;

      TaskService.getTaskList({ ...params })
        .then((r) => {
          this.tasks = r.data.data;
          this.loadingTasks = false;
          setTimeout(() => {
            anime({
              targets: '.task-item',
              opacity: [0, 1],
              duration: 300,
              autoplay: true,
              easing: 'easeOutExpo',
            });
          }, 100);
        })
        .catch(() => {
          this.loadingTasks = false;
        });
    },
    unbindTag(taskId, tagId) {
      this.$set(this.tagLoadings, tagId, true);
      const data = {
        tags: [tagId],
      };
      this.$rHandler(
        this.$api.tasks.unbindTags(taskId, data),
        () => {
          this.$delete(this.tagLoadings, tagId);
          const task = this.tasks.find((t) => t.id === taskId);
          task.tags = task.tags.filter((tag) => tag.id !== tagId);
        },
        () => {
          this.$delete(this.tagLoadings, tagId);
        },
      );
    },
    unbindFromFolder(taskId, folderId) {
      this.$set(this.unbindLoadings, taskId, true);
      const items = [taskId];
      this.$rHandler(
        this.$api.categories.unbindItemsFromCategory(folderId, 'task', items),
        () => {
          this.$delete(this.unbindLoadings, taskId);
          this.$toasted.success('Задание удалено из папки', {
            duration: 3000,
            icon: 'mdi-check',
          });
          this.removeTask(taskId);
        },
        () => {
          this.$delete(this.unbindLoadings, taskId);
        },
      );
    },
    setDataTransfer(e, id) {
      e.dataTransfer.setData('text', id);
    },
    removeTask(taskId) {
      this.tasks = this.tasks.filter((t) => t.id !== taskId);
    },
  },
};
</script>

<style lang="scss" scoped>
.task-item {
  opacity: 0;
}
.ghost {
  //width: 138px;
  max-height: 120px;
  position: relative;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #eee;
    opacity: 50%;
    z-index: 10;
  }
  .v-list-item__action, .tags-container{
    display: none;
  }
}

.handle:hover {
  cursor: grab;
}

.tag__close {
  margin-right: -8px;
  transition: .3s all;
  max-width: 0;

  &--opened {
    max-width: 20px;
  }
}

::v-deep .v-skeleton-loader__task-tags {
  display: flex;
  //padding-top: 10px;
  //padding-bottom: 6px;
  //padding-left: 50px;
  .v-skeleton-loader__chip {
    margin-right: 8px;
    margin-bottom: 8px;
    height: 24px;
  }
}
</style>
